exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pr__icon[data-v-08187fef]{color:#d5d5d8;font-size:10px}.frame[data-v-08187fef]{display:flex;justify-content:center}", ""]);

// exports
